var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteriorPaintFinish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8452 13.1753H35.3296V10.6569C35.3296 9.74325 34.5875 9 33.6748 9L11.155 9.00013C10.2424 9.00013 9.5 9.74328 9.5 10.6571V16.5022C9.5 17.4159 10.2423 18.1592 11.155 18.1592H33.6748C34.5875 18.1592 35.3296 17.416 35.3296 16.5022V13.9839H37.8452C38.3124 13.9839 38.6926 14.3643 38.6926 14.8322V20.6773C38.6926 21.145 38.3124 21.5257 37.8452 21.5257L22.4151 21.5256C22.1924 21.5256 22.0112 21.7069 22.0112 21.9297V25.6577C21.0509 25.7485 20.2943 26.6588 20.2943 27.7649V36.8855C20.2943 38.0516 21.1356 39 22.1698 39H22.6602C23.6942 39 24.5357 38.0516 24.5357 36.8855L24.5355 27.7652C24.5355 26.671 23.7946 25.7683 22.8187 25.661L22.819 22.3341H37.8452C38.7578 22.3341 39.5 21.591 39.5 20.6772V14.832C39.5 13.9185 38.7578 13.1753 37.8452 13.1753ZM34.5221 10.6571V16.5022C34.5221 16.9699 34.1419 17.3506 33.6747 17.3506H11.1549C10.6877 17.3506 10.3075 16.9699 10.3075 16.5022V10.6571C10.3075 10.1894 10.6877 9.80881 11.1549 9.80881H33.6747C34.1419 9.80881 34.5221 10.1892 34.5221 10.6571ZM23.7279 27.7654V36.886C23.7279 37.6061 23.2489 38.1918 22.6601 38.1918H22.1697C21.5808 38.1918 21.1018 37.6061 21.1018 36.886V27.7654C21.1018 27.0453 21.5808 26.4592 22.1697 26.4592H22.6601C23.2489 26.4592 23.7279 27.0453 23.7279 27.7654Z",
    fill: "url(#paint0_linear_2173_8574)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_8574",
    x1: 9.5,
    y1: 24,
    x2: 39.5,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorPaintFinish);
export default __webpack_public_path__ + "static/media/Interior Paint & Finish.c51c1f62ffc998acbcdf498b909ef01b.svg";
export { ForwardRef as ReactComponent };